import { Api } from '../Common/rest-api/api-exports';
import * as _ from 'ramda';

export const getPharmacyListFilter = (data = {}) => {
    return Api.Pharmacies.listFilter(data)
        .then(res => res.body)
        .catch(err => err);
};

export const getPharmacyList = () => {
    return Api.Pharmacies.list()
        .then(res => {
            const phrmaciesList = res.body;
            const pharmaciesCount = res.body.length;

            return _.mergeAll([{ pharmacies: phrmaciesList }, { count: pharmaciesCount }]);
        })
        .catch(err => err);
};

export const getPharmacyListWithoutManagers = id => {
    return Api.Companies.whitoutManager(id)
        .then(res => {
            const phrmaciesList = res.body;
            const pharmaciesCount = res.body.length;

            return _.mergeAll([{ pharmacies: phrmaciesList }, { count: pharmaciesCount }]);
        })
        .catch(err => err);
};

export const getPharmacyListForManager = (userId, companyId) => {
    return Api.Users.single(userId)
        .then(response => {
            let pharmacyOfUser;
            response.body.pharmacy
                ? (pharmacyOfUser = {
                      id: response.body.pharmacy.id,
                      name: response.body.pharmacy.name
                  })
                : (pharmacyOfUser = 'no pharmacy');
            return Api.Companies.whitoutManager(companyId)
                .then(response => {
                    let pharmacyWithoutManagerAndManagerPharmacy;

                    pharmacyOfUser === 'no company'
                        ? (pharmacyWithoutManagerAndManagerPharmacy = response.body)
                        : (pharmacyWithoutManagerAndManagerPharmacy = _.append(pharmacyOfUser, response.body));

                    return pharmacyWithoutManagerAndManagerPharmacy;
                })
                .catch(() => []);
        })
        .catch(() => []);
};

export const getSinglePharmacy = id => {
    return Api.Pharmacies.single(id)
        .then(res => res.body)
        .catch(err => err);
};

export const getSinglePharmacyAppearance = id => {
    return Api.Pharmacies.single(id).then(res => res.body.appearance)
}

export const createPharmacy = details => {
    return Api.Pharmacies.add(details);
};

export const editPharmacy = (details, id) => {
    return Api.Pharmacies.edit(details, id);
};

export const uploadPrices = (details, id) => {
    return Api.Pharmacies.uploadPrices(details, id);
};

export const getServicesList = id => {
    return Api.Pharmacies.servicesList(id)
        .then(res => res.body)
        .catch(err => err);
};

export const createService = (details, pharmacyId) => {
    return Api.Pharmacies.addService(details, pharmacyId);
};

export const getSingleService = (pharmacyId, serviceId) => {
    return Api.Pharmacies.singleService(pharmacyId, serviceId)
        .then(res => res.body[0])
        .catch(err => err);
};

export const editService = (details, pharmacyId, serviceId) => {
    return Api.Pharmacies.editService(details, pharmacyId, serviceId);
};

export const orderServiceList = (details, pharmacyId, language) => {
    return Api.Pharmacies.orderListService(details, pharmacyId, language);
};

export const getNationalHolidays = () => {
    return Api.Pharmacies.nationalHolidays()
        .then(res => res.body)
        .catch(err => err);
};

export const searchPatients = (pharmacyId, queryString) => {
    return Api.Pharmacies.searchPatientsList(pharmacyId, queryString)
    .then(res => res.body)
    .catch(err => err);
}

export const patientsWhiteList = (pharmacyId, queryString) => {
    return Api.Pharmacies.getPatientsWhiteList(pharmacyId, queryString)
    .then(res => res.body)
    .catch(err => err);
}

export const editPatientsWhiteList = (details, pharmacyId) => {
    return Api.Pharmacies.editWhiteList(details, pharmacyId)
    .then(res => res.body)
    .catch(err => err);
}

export const patientsWhiteListCourier = (pharmacyId, queryString) => {
    return Api.Pharmacies.getPatientsWhiteListCourier(pharmacyId, queryString)
    .then(res => res.body)
    .catch(err => err);
}

export const editPatientsWhiteListCourier = (details, pharmacyId) => {
    return Api.Pharmacies.editWhiteListCourier(details, pharmacyId)
    .then(res => res.body)
    .catch(err => err);
}



// WEBPACK FOOTER //
// ./src/customModules/Pharmacies/epics-pharmacies.js